<template>
  <div class="data-report-wrapper">
    <div class="header">
      <div class="left-content">
        <div class="name">待办事项</div>
        <div class="data-info">
          <div>
            <div @click="goToPage(1)">待处理订单</div>
            <div style="color:#f00">{{ databoardData.order_nd_num }}</div>
          </div>
          <div>
            <div @click="goToPage(2)">待处理售后单</div>
            <div>{{ databoardData.as_order_ne_num }}</div>
          </div>
          <div>
            <div @click="goToPage(3)">待处理工单</div>
            <div>{{ databoardData.as_order_wo_num.total }}</div>
          </div>
          <div>
            <div @click="goToPage(4)">库存缺货</div>
            <div>{{ databoardData.stock_warn_num }}</div>
          </div>
        </div>
      </div>
      <div
        class="right-content-style"
        v-show="showWarnData"
        style="padding-left: 30px"
      >
        <div class="name">异常订单数据展示</div>
        <div class="data-info">
          <div>
            <div @click="goToPage(5)">超时未到分仓</div>
            <div>{{ databoardData.order_to_num }}(单)</div>
          </div>
          <div>
            <div @click="goToPage(6)">售后单超时未到分仓</div>
            <div>{{ databoardData.as_order_to_num }}(单)</div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-wrapper">
      <div class="data-header bottom-style">
        <span>数据展示</span>
        <span
          >（统计时间：{{
            datareportDateList[datareportDateList.length - 1]
          }}）</span
        >
        <span>按自然日来统计</span>
      </div>
      <div class="data-content">
        <div
          :class="{ 'active-data': activeEchartIndex === 1 }"
          @click="loadEchartData(1)"
        >
          <div>
            及时出库率
            <el-tooltip
              class="item"
              effect="dark"
              content="系统发货时间内发货的订单数/有效推单数；"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <div>{{ dg_order_rate[dg_order_rate.length - 1] }}%</div>
        </div>
        <div
          :class="{ 'active-data': activeEchartIndex === 2 }"
          @click="loadEchartData(2)"
        >
          <div>
            拒单率
            <el-tooltip
              class="item"
              effect="dark"
              content="店铺拒单的子单数量/非客户取消的子单数量；"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <div>{{ rs_order_rate[rs_order_rate.length - 1] }}%</div>
        </div>
        <div
          :class="{ 'active-data': activeEchartIndex === 3 }"
          @click="loadEchartData(3)"
        >
          <div>
            当月缺货率
            <el-tooltip
              class="item"
              effect="dark"
              content="库存预警的SKU数 / 店铺启用SKU数；"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <div>{{ sw_goods_rate[sw_goods_rate.length - 1] }}%</div>
        </div>
        <div
          v-show="showWarnData"
          :class="{ 'active-data': activeEchartIndex === 4 }"
          @click="loadEchartData(4)"
        >
          <div>
            售后及时处理率
            <el-tooltip
              class="item"
              effect="dark"
              content="一定时效内(出库后自然日两天)处理的售后订单数/总售后订单数(当月全量)"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <div>{{ hd_as_order_rate[hd_as_order_rate.length - 1] }}%</div>
        </div>
      </div>
    </div>
    <div class="right-data">
      <span :class="{ 'active-tab': activeDate === 1 }" @click="loadDateData(1)"
        >近7天</span
      >
      <span :class="{ 'active-tab': activeDate === 2 }" @click="loadDateData(2)"
        >近30天</span
      >
    </div>
    <!-- 图表 -->
    <div id="container"></div>
    <el-dialog
      :visible.sync="dialogVisible"
      class="data-dialog"
      width="50%"
      center
      :append-to-body="true"
      :before-close="handleClose"
    >
      <div slot="title" class="dialog-title">
        待处理工单：{{ databoardData.as_order_wo_num.total }}
      </div>
      <div class="title-tip">
        <div @click="goToPage(7)">
          我创建的：{{ databoardData.as_order_wo_num.mc }}
        </div>
        <div @click="goToPage(8)">
          我受理的：{{ databoardData.as_order_wo_num.mh }}
        </div>
      </div>
      <div class="content">
        <div class="left-content">
          <div>
            <span>已处理：{{ databoardData.as_order_wo_num.mc_ycl }}</span>
            <span>新建：{{ databoardData.as_order_wo_num.mc_new }}</span>
          </div>
          <div>
            <span>开始处理：{{ databoardData.as_order_wo_num.mc_kcl }}</span>
            <span>驳回处理：{{ databoardData.as_order_wo_num.mc_back }}</span>
          </div>
        </div>
        <div class="right-content">
          <div>
            <span>新建：{{ databoardData.as_order_wo_num.mh_new }}</span>
            <span>驳回处理：{{ databoardData.as_order_wo_num.mh_back }}</span>
          </div>
          <div>
            <span>已处理：{{ databoardData.as_order_wo_num.mh_ycl }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 公告弹框 -->
    <NoticeDialog></NoticeDialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { queryDataboard, queryDatareport } from "../../models/dataReportmodel";
import dataReportApiList from "../../service/basic/dataReportApiList";
// import NoticeDialog from "@/components/notice";
import NoticeDialog from "@/components/notice/indexNew.vue";
// const neffos = require('@/assets/js/neffos.js');
const neffos = require("neffos.js");
export default {
  name: "dataReport",
  components: {
    NoticeDialog
  },
  data() {
    return {
      showWarnData: false,
      activeEchartIndex: 1,
      activeDate: 1,
      databoardData: {
        as_order_ne_num: null, //待处理售后单
        as_order_to_num: null, //售后单超时未到分仓
        as_order_wo_num: {
          mc: null, //我创建的
          mc_back: null, //我创建的-驳回处理
          mc_kcl: null, //我创建的-开始处理
          mc_new: null, //我创建的-新建
          mc_ycl: null, //我创建的-已处理
          mh: null, //我处理的
          mh_back: null, //我处理的-驳回处理
          mh_new: null, //我处理的-新建
          mh_ycl: null, //我处理的-已处理
          total: null //总待处理工单=我创建的+我处理的
        }, //待处理工单
        order_nd_num: null, //待处理订单
        order_to_num: null, //超时未到分仓
        stock_warn_num: null //库存缺货
      },
      datareportDateList: [], // 图表日期
      dg_order_rate: [], //及时出库率，为null时代表无数据
      hd_as_order_rate: [], //售后及时处理率，为null时代表无数据
      rs_order_rate: [], //拒单率，为null时代表无数据
      sw_goods_rate: [], //当月缺货率，为null时代表无数据
      echartData: [], // 图表数据
      dialogVisible: false // 弹窗
    };
  },
  mounted() {
    // console.log(neffos, "neffos");
    this.loadDataboard();
    this.loadDatareport(7);
    // this.goWebSocket();
    this.goNeffos();
    this.showWarnData = localStorage.getItem("shop_type") === "0"; // 只有平台才显示异常订单数据
  },
  methods: {
    handleClose(done) {
      this.dialogVisible = false;
    },
    loadEchartData(type) {
      console.log(type, "type");
      switch (type) {
        case 1:
          this.activeEchartIndex = 1;
          this.echartData = this.dg_order_rate;
          break;
        case 2:
          this.activeEchartIndex = 2;
          this.echartData = this.rs_order_rate;
          break;
        case 3:
          this.activeEchartIndex = 3;
          this.echartData = this.sw_goods_rate;
          break;
        case 4:
          this.activeEchartIndex = 4;
          this.echartData = this.hd_as_order_rate;
          break;
      }
      this.initEchart();
      console.log(this.echartData, "this.echartData");
    },
    loadDateData(type) {
      switch (type) {
        case 1:
          this.activeDate = 1;
          this.loadDatareport(7);
          break;
        case 2:
          this.activeDate = 2;
          this.loadDatareport(30);
          this.loadEchartData(1);
          break;
      }
    },
    goWebSocket() {
      if ("WebSocket" in window) {
        console.log("您的浏览器支持 WebSocket!");
        const url =
          webSockethostname +
          dataReportApiList.getSystemWs +
          "?token=" +
          localStorage.getItem("token");
        console.log(url, "url11");
        // 打开一个 web socket
        let ws = new WebSocket(url);

        ws.onopen = () => {
          // Web Socket 已连接上，使用 send() 方法发送数据
          ws.send("发送数据");
          console.log("数据发送中...");
        };

        ws.onmessage = evt => {
          console.log("数据已接收...", evt.data);
          const received_msg = evt.data;
          if (received_msg.key === "as_order_ne_num") {
            //待处理售后单
            this.databoardData.as_order_ne_num = received_msg.num;
          } else if (received_msg.key === "as_order_wo_num") {
            //待处理工单
            // this.databoardData.as_order_wo_num = received_msg.num
          } else if (received_msg.key === "order_nd_num") {
            //待处理订单
            this.databoardData.order_nd_num = received_msg.num;
          } else if (received_msg.key === "stock_warn_num") {
            //库存缺货
            this.databoardData.stock_warn_num = received_msg.num;
          }
        };

        ws.onclose = () => {
          // 关闭 websocket
          console.log("连接已关闭...");
          this.reconnect();
        };

        ws.onerror = err => {
          // 发生错误
          ws.close(); // 主动关闭连接
          console.log("发生错误...", err);
        };
      } else {
        // 浏览器不支持 WebSocket
        alert("您的浏览器不支持 WebSocket!");
      }
    },
    reconnect() {
      this.goWebSocket();
    },
    async goNeffos() {
      let timer = undefined;
      try {
        const url =
          webSockethostname +
          "/system/ws?token=" +
          localStorage.getItem("token");
        let webSocket = await neffos.dial(
          url,
          {
            system: {
              // "default" namespace.
              _OnNamespaceConnected: (ns, msg) => {
                console.log("连接成功", msg);
                timer = setInterval(() => {
                  console.log("ping---");
                  ns.emit("OnPing", "1111111111111");
                }, 50000);
              },
              _OnNamespaceDisconnect: (ns, msg) => {
                console.log("连接断开", msg);
                clearInterval(timer);
              },
              notifyShopDataboard: (ns, msg) => {
                // 获取后端返回值
                console.log(msg, "msg");
                const received_msg = msg.Body
                  ? JSON.parse(msg.Body)
                  : { key: "", num: "" };
                console.log(received_msg, "received_msg");
                console.log(
                  received_msg.shop_id ===
                    Number(localStorage.getItem("shop_id")),
                  "999999"
                );
                if (
                  received_msg.shop_id ===
                  Number(localStorage.getItem("shop_id"))
                ) {
                  // 如果是当前店铺的则更新对应值
                  if (received_msg.key === "as_order_ne_num") {
                    //待处理售后单
                    this.databoardData.as_order_ne_num = received_msg.num;
                  } else if (received_msg.key === "as_order_wo_num") {
                    //待处理工单
                    // this.databoardData.as_order_wo_num = received_msg.num
                  } else if (received_msg.key === "order_nd_num") {
                    //待处理订单
                    this.databoardData.order_nd_num = received_msg.num;
                  } else if (received_msg.key === "stock_warn_num") {
                    //库存缺货
                    this.databoardData.stock_warn_num = received_msg.num;
                    console.log(this.databoardData.stock_warn_num);
                  }
                }
              },
              notifyShopPendingOrder: (ns, msg) => {
                // 获取后端返回值
                console.log(msg, "msg-pending");
                const received_msg = msg.Body ? JSON.parse(msg.Body) : [];
                const shop_id = Number(localStorage.getItem("shop_id"));

                if (received_msg.indexOf(shop_id) > -1) {
                  this.$store.dispatch("app/isQueryPendingOrder", "order");
                }
              }
            }
          },
          {
            reconnect: 3000
          }
        );
        console.log(webSocket, "webSocket");
        await webSocket.connect("system");
      } catch (err) {
        console.log(err, "err");
      }
    },
    heartCheck(webSocket) {
      var heart = {
        timeout: 5000, //50秒
        timeoutObj: null,
        serverTimeoutObj: null,
        reset: function() {
          console.log("reset-------");
          clearTimeout(this.timeoutObj);
          clearTimeout(this.serverTimeoutObj);
          return this;
        },
        start: function() {
          console.log("start-------");
          var self = this;
          this.timeoutObj = setTimeout(function() {
            //这里发送一个心跳，后端收到后，返回一个心跳消息，
            //onmessage拿到返回的心跳就说明连接正常
            webSocket.connect("OnPing"); //发送这个消息的时候，必须让后端收到消息后，立马发送一个消息，这样来回一个接收过程，就可以判断当前还没有断开连接。
            self.serverTimeoutObj = setTimeout(function() {
              //如果超过一定时间还没重置，说明后端主动断开了
              webSocket.close(); //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
            }, self.timeout);
          }, 5000);
        }
      };
      return heart;
    },
    goToPage(type) {
      switch (type) {
        case 1:
          this.$router.push({ path: "/order/manage", query: {} });
          localStorage.setItem("menuActive", "/order/manage");
          break;
        case 2:
          this.$router.push({ path: "/afterSale/manage", query: {} });
          localStorage.setItem("menuActive", "/afterSale/manage");
          break;
        case 3:
          this.dialogVisible = true;
          break;
        case 4:
          this.$router.push({ path: "/stock/manage", query: {} });
          localStorage.setItem("menuActive", "/stock/manage");
          break;
        case 5:
          this.$router.push({
            path: "/order/manage",
            query: { statusActive: "4" }
          });
          localStorage.setItem("menuActive", "/order/manage?statusActive=4");
          break;
        case 6:
          this.$router.push({
            path: "/afterSale/manage",
            query: { statusActive: "3" }
          });
          localStorage.setItem(
            "menuActive",
            "/afterSale/manage?statusActive=3"
          );
          break;
        case 7:
          this.$router.push({ path: "/orderList/work", query: {} });
          localStorage.setItem("menuActive", "/orderList/work");
          break;
        case 8:
          this.$router.push({
            path: "/orderList/work",
            query: { activeColor: "2" }
          });
          localStorage.setItem("menuActive", "/orderList/work?activeColor=2");
          break;
      }
    },
    loadDataboard() {
      const params = {
        shop_id: localStorage.getItem("shop_id")
      };
      queryDataboard(params)
        .then(res => {
          console.log(res);
          this.databoardData = res;
        })
        .catch(err => {
          console.log(err);
          this.$message.error(err.message);
        });
    },
    loadDatareport(day_num) {
      const params = {
        shop_id: localStorage.getItem("shop_id"),
        day_num
      };
      queryDatareport(params)
        .then(res => {
          console.log(res);
          const returnData = res || [];
          const dateList = [];
          const dg_order_rate_copy = [];
          const hd_as_order_rate_copy = [];
          const rs_order_rate_copy = [];
          const sw_goods_rate_copy = [];
          returnData.map(item => {
            dateList.push(item.date);
            dg_order_rate_copy.push(item.dg_order_rate);
            hd_as_order_rate_copy.push(item.hd_as_order_rate);
            rs_order_rate_copy.push(item.rs_order_rate);
            sw_goods_rate_copy.push(item.sw_goods_rate);
          });
          this.datareportDateList = dateList;
          this.dg_order_rate = dg_order_rate_copy;
          this.hd_as_order_rate = hd_as_order_rate_copy;
          this.rs_order_rate = rs_order_rate_copy;
          this.sw_goods_rate = sw_goods_rate_copy;
          this.echartData = dg_order_rate_copy;
          console.log(this.datareportDateList, "this.datareportDateList");
          console.log(this.echartData, "this.echartData");
          this.initEchart();
        })
        .catch(err => {
          console.log(err);
          this.$message.error(err.message);
        });
    },
    initEchart() {
      let chartDom = document.getElementById("container");
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        xAxis: {
          type: "category",
          data: this.datareportDateList
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}%"
          }
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          axisPointer: {
            type: "line",
            label: {
              fontSize: 13,
              fontFamily: "PingFangSC-Regular, PingFang SC",
              fontWeight: 400,
              color: "#fff"
            }
          },
          borderWidth: 0,
          textStyle: {
            fontSize: 13,
            fontFamily: "PingFangSC-Regular, PingFang SC",
            fontWeight: 400,
            color: "#fff"
          },
          formatter: "{b}: {c}%"
        },
        series: [
          {
            data: this.echartData,
            type: "line",
            showSymbol: false,
            smooth: false,
            connectNulls: true, // 是否连接空数据。
            lineStyle: {
              color: "#F95656"
            },
            itemStyle: {
              color: "#F95656"
            }
          }
        ]
      };
      option && myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss">
.data-report-wrapper {
  width: 100%;
  overflow-x: hidden;
  #container {
    width: 100%;
    height: 500px;
  }
  .no-data {
    width: 100%;
    height: 200px;
    text-align: center;
    line-height: 200px;
  }
  .header {
    width: 100%;
    padding: 20px 10px;
    border-bottom: 1px solid #ddd;
    display: flex;
    flex-direction: row;
    > div {
      width: 90%;
    }
    .data-info {
      display: flex;
      flex-direction: row;
      > div {
        width: 90%;
        text-align: center;
        cursor: pointer;
        background: rgb(237, 237, 237);
        padding: 5px 0px;
        border-radius: 8px;
        margin-right: 8px;
      }
    }
    .name {
      margin-bottom: 20px;
      font-weight: 500;
    }
  }
  .data-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    > span {
      font-size: 16px;
      font-weight: 500;
    }
  }
  .data-wrapper {
    width: 100%;
    padding: 20px 10px;
    .data-content {
      display: flex;
      flex-direction: row;
      > div {
        width: 90%;
        border: 1px solid #ddd;
        margin-right: 10px;
        padding: 10px;
        text-align: center;
        cursor: pointer;
        border-radius: 8px;
      }
      .active-data {
        border: 1px solid #ff6224;
      }
    }
  }
  .right-data {
    width: 100%;
    text-align: right;
    > span {
      padding: 5px 10px;
      border: 1px solid #2c3e50;
      border-radius: 8px;
      margin-left: 8px;
      cursor: pointer;
    }
    .active-tab {
      background: #ff6224;
      color: #fff;
      border: 1px solid #ff6224;
    }
  }
  .bottom-style {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/dataReport/dataReport.vue